import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'content-component',
  templateUrl: './content-component.component.html',
  styleUrls: ['./content-component.component.scss']
})
export class ContentComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
